import { xMean } from 'ml-spectra-processing';
export function removeDCOffset(data, options) {
    let { digitalFilterValue = 0 } = options;
    const nbPoints = data.re.length;
    const newRe = new Float64Array(data.re);
    const newIm = new Float64Array(data.im);
    const averageRe = xMean(data.re.slice((nbPoints * 0.75) >> 0, nbPoints - digitalFilterValue));
    const averageIm = xMean(data.im.slice((nbPoints * 0.75) >> 0, nbPoints - digitalFilterValue));
    for (let i = digitalFilterValue; i < nbPoints - digitalFilterValue; i++) {
        newRe[i] -= averageRe;
        newIm[i] -= averageIm;
    }
    return { re: newRe, im: newIm };
}
//# sourceMappingURL=removeDCOffset.js.map